/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.1.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WatchdogEvent } from './WatchdogEvent';
import {
    WatchdogEventFromJSON,
    WatchdogEventFromJSONTyped,
    WatchdogEventToJSON,
} from './WatchdogEvent';

/**
 * 
 * @export
 * @interface WatchdogEventList
 */
export interface WatchdogEventList {
    /**
     * 
     * @type {Array<WatchdogEvent>}
     * @memberof WatchdogEventList
     */
    records?: Array<WatchdogEvent>;
}

/**
 * Check if a given object implements the WatchdogEventList interface.
 */
export function instanceOfWatchdogEventList(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WatchdogEventListFromJSON(json: any): WatchdogEventList {
    return WatchdogEventListFromJSONTyped(json, false);
}

export function WatchdogEventListFromJSONTyped(json: any, ignoreDiscriminator: boolean): WatchdogEventList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'records': !exists(json, 'records') ? undefined : ((json['records'] as Array<any>).map(WatchdogEventFromJSON)),
    };
}

export function WatchdogEventListToJSON(value?: WatchdogEventList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'records': value.records === undefined ? undefined : ((value.records as Array<any>).map(WatchdogEventToJSON)),
    };
}

